global.megasearch = (function() {
	var module = {};

	//Search variables
	var $search = $('#megasearch form'),
		$input = $( '.search-input' ),
		$close = $( 'span.search-close' ),
		isOpen = false,
		isAnimating = false;

	module.search = function(searchTerms){

		var $results = $('#megasearch .results'), results;

		if (typeof searchTerms !== 'undefined' && searchTerms !== null && /\S/.test(searchTerms)) {
			$.cookie('megasearchTerms', searchTerms, { expires: 1, path: '/' });
			var terms = searchTerms.replace(/\,/g, ' ').replace(/  /g, ' ');
			var terms = terms.match(/ /g) ? terms.split(' ') : [terms],
				search = {
					terms : [],
					fullSearch : searchTerms
				};

			for (var i = 0; i<terms.length; i++) {
				if (terms[i] != ' ' && terms[i] != '' ) {
					search.terms.push(terms[i]);
				}
			}

			$results.html('<div class="loader"/>');

			if (locationSuccessful) {
				search.userLocation = [userLat, userLon];
			}

			var template;
			$.ajax({
				url : '/stage-ajax/megasearch?stage-language=fi&v=20',
				data : search,
				success : function(data){
					results = data ? data.results : false;
					template = data ? data.template : false;
					window.history.pushState('forward', null, './#megasearch');
				},
				complete : function(){
					var rendered = Mustache.render(template, results);
					$results.html(rendered);
					if($results.find('.used-cars .show-all-cars').length){
						var allUsedCarsUrl = $results.find('.used-cars .show-all-cars').attr('href').split('?')[0];
						$results.find('.used-cars .show-all-cars').attr('href', allUsedCarsUrl+'?type[]=used&megasearch[]='+search.terms.join(' '));
						$results.find('.used-cars .h6 a').attr('href', allUsedCarsUrl+'?type[]=used&megasearch[]='+search.terms.join(' '));
					}
					if($results.find('.stock-cars .show-all-cars').length){
						var allUsedCarsUrl = $results.find('.stock-cars .show-all-cars').attr('href').split('?')[0];
						$results.find('.stock-cars .show-all-cars').attr('href', allUsedCarsUrl+'?type[]=stock&megasearch[]='+search.terms.join(' '));
						$results.find('.stock-cars .h6 a').attr('href', allUsedCarsUrl+'?type[]=stock&megasearch[]='+search.terms.join(' '));
					}
					if($results.find('.new-cars .show-all-cars').length){
						var allUsedCarsUrl = $results.find('.new-cars .show-all-cars').attr('href').split('?')[0];
						$results.find('.new-cars .show-all-cars').attr('href', allUsedCarsUrl+'?type[]=new&megasearch[]='+search.terms.join(' '));
						$results.find('.new-cars .h6 a').attr('href', allUsedCarsUrl+'?type[]=new&megasearch[]='+search.terms.join(' '));
					}
				},
				error : function(e){
					console.log('ERROR! Megasearch failed!');
					console.log(e);
				}
			});


		} else {
			$results.empty();
		}
	};

	return module;
})();

//megasearch events
(function (){
	var searchTimer;
	$('#megasearch form').on('keyup', 'input', function(e){
		clearTimeout(searchTimer);

		var keyCode = e.keyCode || e.which,
			val = $(this).val();

			searchTimer = setTimeout(function(){
				megasearch.search(val);
			}, 1000);

	}).submit(function(e){ e.preventDefault(); });

	$('#megasearch a.close').click(function(e) {
		e.preventDefault();
		navigation.toggle('#megasearch', $('li.megasearch a'));
	  	$('html').css('overflow', 'auto');
	});

	$(document).keyup(function(e) {
	  if (e.keyCode == 27  && $('#megasearch').hasClass('active') ) { //escape
		  navigation.toggle('#megasearch', $('li.megasearch a'));
		  $('html').css('overflow', 'auto');
	  }
	});

})();